[
  {
    "id": 1,
    "position": "AI/ML Virtual Intern",
    "company": "IBM SkillsBuild (PBEL Program)",
    "location": "Remote",
    "startDate": "2026-06",
    "endDate": "2026-08",
    "current": false,
    "description": "Architected a full-stack threat-intelligence system ingesting network traffic and training a Random Forest classifier. Built automated preprocessing pipelines (Pandas, Scikit-learn) and delivered a dual-server architecture with FastAPI inference backend and a Flask dashboard in a 2-month agile sprint.",
    "technologies": [
      "Python",
      "FastAPI",
      "Flask",
      "Pandas",
      "Scikit-learn",
      "Random Forest",
      "REST API"
    ]
  },
  {
    "id": 2,
    "position": "Full Stack Developer",
    "company": "Devstack Technologies",
    "location": "Remote",
    "startDate": "2026-04",
    "endDate": "2026-06",
    "current": false,
    "description": "Shipped end-to-end full-stack features using React and FastAPI/Node.js. Built RESTful APIs with MongoDB and MySQL, implementing auth and real-time WebSockets. Integrated ML inference APIs for real-time NLP predictions and automated CI/CD with Docker and GitHub Actions.",
    "technologies": [
      "React",
      "FastAPI",
      "Node.js",
      "MongoDB",
      "MySQL",
      "WebSockets",
      "Docker",
      "GitHub Actions",
      "NLP"
    ]
  }
]